document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('.mobile-menu-toggle');
  const menu=document.querySelector('.mobile-menu');
  if(toggle&&menu){
    toggle.addEventListener('click',()=>{
      const open=toggle.getAttribute('aria-expanded')==='true';
      toggle.setAttribute('aria-expanded',String(!open));
      menu.hidden=open;
      menu.setAttribute('aria-open',String(!open));
    });
  }
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
    form.addEventListener('submit',()=>{
      const button=form.querySelector('button[type="submit"]');
      if(button){button.disabled=true;button.textContent='ADDING…';}
    });
  });
});
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-product-tabs] .product-tab-toggle').forEach(button=>{
    button.addEventListener('click',()=>{
      const panel=document.getElementById(button.getAttribute('aria-controls'));
      if(!panel) return;
      const expanded=button.getAttribute('aria-expanded')==='true';
      button.setAttribute('aria-expanded',String(!expanded));
      panel.hidden=expanded;
      const icon=button.querySelector('.tab-plus');
      if(icon) icon.textContent=expanded?'+':'−';
    });
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  const setupDropdown=(button,menu)=>{
    if(!button||!menu) return;
    button.addEventListener('click',()=>{
      const open=button.getAttribute('aria-expanded')==='true';
      button.setAttribute('aria-expanded',String(!open));
      menu.hidden=open;
      const icon=button.querySelector('.help-chevron');
      if(icon) icon.textContent=open?'+':'−';
    });
  };

  setupDropdown(
    document.querySelector('.help-toggle'),
    document.querySelector('#HelpDropdown')
  );

  const mobileHelpButton=document.querySelector('.mobile-help-toggle');
  const mobileHelpMenu=document.querySelector('#MobileHelpDropdown');
  if(mobileHelpButton&&mobileHelpMenu){
    mobileHelpButton.addEventListener('click',()=>{
      const open=mobileHelpButton.getAttribute('aria-expanded')==='true';
      mobileHelpButton.setAttribute('aria-expanded',String(!open));
      mobileHelpMenu.hidden=open;
      const parts=mobileHelpButton.querySelectorAll('span');
      if(parts.length>1) parts[1].textContent=open?'+':'−';
    });
  }
});


document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-cart-remove]').forEach(button=>{
    button.addEventListener('click',async()=>{
      const key=button.getAttribute('data-cart-remove');
      if(!key) return;
      button.disabled=true;
      button.textContent='REMOVING…';
      try{
        const response=await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/')+'cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:key,quantity:0})
        });
        if(!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      }catch(error){
        button.disabled=false;
        button.textContent='REMOVE ITEM';
      }
    });
  });
});
